module.exports = __webpack_public_path__ + "img/circle-attention.0e6fe0a2.svg";